<script setup>
import { computed } from "vue";
import { curriculumIntegrationVizSource } from "@/composables/tableau.js";
import VizLoader from "@/components/VizLoader/index.vue";
import { useStore } from "vuex";
import { TABLEAU_PAGE_HEIGHT } from "@/constants.js";

defineOptions({
  name: "CurriculumIntegrationDashboard",
});

const store = useStore();
const selectedEntity = computed(() => {
  return store.getters["programManager/getSelectedEntityView"];
});

const filtersObj = computed(() => {
  return [
    {
      name: "ENTITY_ID",
      value: selectedEntity.value.id,
    },
  ];
});
</script>

<template>
  <div class="w-full bg-blue-100 text-sm text-indigo-base">
    <div
      class="flex flex-col items-baseline justify-between"
      data-testid="curriculum-integration-app-embed"
      :style="{ height: `${TABLEAU_PAGE_HEIGHT}px` }"
    >
      <VizLoader :key="selectedEntity.id" :src="curriculumIntegrationVizSource" :filters="filtersObj" />
    </div>
  </div>
</template>
